

















import { Component, Vue, Prop, Mixins } from 'vue-property-decorator';
import { IRelay } from '../store/views/relaysView/types';
import { RelaysState, IRelayState } from '../store/relays/types';
import { State, Getter, Action } from 'vuex-class';
import RelayMixin from '@/mixins/RelayMixin';


@Component({ })
export default class RelayButton extends Mixins(RelayMixin) {
    @Prop({required: true})
    public deviceNumber: string;

    @Prop({required: true})
    public relayInput: IRelay;

    public mounted() {
        this.setRelayInfo(this.deviceNumber, this.relayInput);
    }

}
